import React, { useEffect ,useState} from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";
import Service from "../service/Service";


import "./styles/contact.css";

const Contact = () => {
	const [data, setData] = useState([]);
	
	useEffect(() => {
	  getData();
	}, []);
  
	const getData = async () => {
	  try {
		const documentData = await Service.getInfoById("contact");
		if (documentData) {
		  setData(documentData);
		}
	  } catch (error) {
		console.error("Error fetching data:", error);
	  }
	};
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	

	return (
		<React.Fragment>
		

			<div className="page-content">
				<NavBar active="contact" />
				<div className="content-wrapper">
					<div className="contact-logo-container">
						<div className="contact-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="contact-container">
						<div className="title contact-title">
							{data.title}
						</div>

						<div className="subtitle contact-subtitle">
							{data.desc}
						</div>
					</div>

					<div className="socials-container">
						<div className="contact-socials">
							<Socials />
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Contact;
